import { render, staticRenderFns } from "./WVuetifyColorPicker.vue?vue&type=template&id=a579a77a&scoped=true&"
import script from "./WVuetifyColorPicker.vue?vue&type=script&lang=js&"
export * from "./WVuetifyColorPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a579a77a",
  null
  
)

export default component.exports